import { render, staticRenderFns } from "./psuIndex.vue?vue&type=template&id=bb1afa7a&scoped=true"
import script from "./psuIndex.vue?vue&type=script&lang=js"
export * from "./psuIndex.vue?vue&type=script&lang=js"
import style0 from "./psuIndex.vue?vue&type=style&index=0&id=bb1afa7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb1afa7a",
  null
  
)

export default component.exports